export default "__VITE_ASSET__CBc8ZrRI__"